<template>
  <div class="business-card">
    <div class="business-title">业务数据</div>
    <el-tabs v-model="activeTab" @tab-click="handleTabClick" v-if="hasAnyData">
      <el-tab-pane label="土地流转" name="landTransferData" v-if="hasLandTransferData">
        <LandTransferDataTab :landTransferInfoList="landTransferInfoList" />
      </el-tab-pane>
      <el-tab-pane
        label="涉农补贴"
        name="agriculturalSubsidyData"
        v-if="hasAgriculturalSubsidyData"
      >
        <AgriculturalSubsidyDataTab
          :majorGrainGrowerInfoList="majorGrainGrowerInfoList"
          :machinePurchaseInfoList="machinePurchaseInfoList"
          :socialServiceInfoList="socialServiceInfoList"
        />
      </el-tab-pane>
      <el-tab-pane label="承包权" name="contractData" v-if="hasContractData">
        <ContractDataTab :contractInfoList="contractInfoList" />
      </el-tab-pane>
      <el-tab-pane label="仓储仓单" name="warehouseData" v-if="hasWarehouseData">
        <WarehouseReceiptDataTab :warehouseReceiptInfoList="warehouseReceiptInfoList" />
      </el-tab-pane>
      <el-tab-pane label="土地托管" name="entrustedData" v-if="hasEntrustedData">
        <EntrustedDataTab :entrustedInfoList="entrustedInfoList" />
      </el-tab-pane>
      <el-tab-pane label="房地产" name="realEstateData" v-if="hasRealEstateData">
        <RealEstateDataTab :realEstateInfoList="realEstateInfoList" />
      </el-tab-pane>
      <el-tab-pane label="婚姻状况" name="marriageStatus" v-if="hasMarriageStatusData">
        <MarriageStatusTab :marriageStatusInfoList="marriageStatusInfoList" />
      </el-tab-pane>
      <el-tab-pane label="社保" name="socialSecurity" v-if="hasSocialSecurityData">
        <SocialSecurityTab :socialSecurityInfoList="socialSecurityInfoList" />
      </el-tab-pane>
      <el-tab-pane label="医保" name="medicalInsurance" v-if="hasMedicalInsuranceData">
        <MedicalInsuranceTab :medicalInsuranceInfoList="medicalInsuranceInfoList" />
      </el-tab-pane>
      <el-tab-pane
        label="财务报表"
        name="financialReport"
        v-if="hasFinancialReportData"
      >
        <FinancialReportTab :financialReportInfoList="financialReportInfoList" />
      </el-tab-pane>
    </el-tabs>
    
    <!-- 暂无业务数据提示 -->
    <div v-if="!hasAnyData" class="no-data-container">
      <div class="no-data-icon">
        <i class="el-icon-document"></i>
      </div>
      <div class="no-data-text">暂无业务数据</div>
      <div class="no-data-desc">当前用户暂无相关业务数据信息</div>
    </div>
  </div>
</template>

<script>
import FinancialReportTab from './FinancialReportTab.vue'
import EntrustedDataTab from './EntrustedDataTab.vue'
import RealEstateDataTab from './RealEstateDataTab.vue'
import MarriageStatusTab from './MarriageStatusTab.vue'
import LandTransferDataTab from './LandTransferDataTab.vue'
import AgriculturalSubsidyDataTab from './AgriculturalSubsidyDataTab.vue'
import ContractDataTab from './ContractDataTab.vue'
import WarehouseReceiptDataTab from './WarehouseReceiptDataTab.vue'
import SocialSecurityTab from './SocialSecurityTab.vue'
import MedicalInsuranceTab from './MedicalInsuranceTab.vue'

export default {
  name: 'BusinessInfoCard',
  components: {
    FinancialReportTab,
    EntrustedDataTab,
    RealEstateDataTab,
    MarriageStatusTab,
    LandTransferDataTab,
    AgriculturalSubsidyDataTab,
    ContractDataTab,
    WarehouseReceiptDataTab,
    SocialSecurityTab,
    MedicalInsuranceTab
  },
  props: {
    businessInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      activeTab: 'landTransferData'
    }
  },
  computed: {
    landTransferInfoList() {
      return this.businessInfo.landTransferList || []
    },
    majorGrainGrowerInfoList() {
      return this.businessInfo.grainSubsidyList || []
    },
    machinePurchaseInfoList() {
      return this.businessInfo.machinerySubsidyList || []
    },
    socialServiceInfoList() {
      return this.businessInfo.socialServiceSubsidyList || []
    },
    financialReportInfoList() {
      return this.businessInfo.reportList || []
    },
    contractInfoList() {
      return this.businessInfo.contractList || []
    },
    warehouseReceiptInfoList() {
      return this.businessInfo.warehouseList || []
    },
    entrustedInfoList() {
      return this.businessInfo.trusteeList || []
    },
    realEstateInfoList() {
      return this.businessInfo.realEstateList || []
    },
    marriageStatusInfoList() {
      return this.businessInfo.marriageStatusList || []
    },
    socialSecurityInfoList() {
      return this.businessInfo.socialSecurityList || []
    },
    medicalInsuranceInfoList() {
      return this.businessInfo.medicalInsuranceList || []
    },

    // 各标签页是否有数据的条件判断
    hasLandTransferData() {
      return this.landTransferInfoList.length > 0
    },
    hasAgriculturalSubsidyData() {
      return this.majorGrainGrowerInfoList.length > 0 ||
             this.machinePurchaseInfoList.length > 0 ||
             this.socialServiceInfoList.length > 0
    },
    hasContractData() {
      return this.contractInfoList.length > 0
    },
    hasWarehouseData() {
      return this.warehouseReceiptInfoList.length > 0
    },
    hasEntrustedData() {
      return this.entrustedInfoList.length > 0
    },
    hasRealEstateData() {
      return this.realEstateInfoList.length > 0
    },
    hasMarriageStatusData() {
      return this.marriageStatusInfoList.length > 0
    },
    hasSocialSecurityData() {
      return this.socialSecurityInfoList.length > 0
    },
    hasMedicalInsuranceData() {
      return this.medicalInsuranceInfoList.length > 0
    },
    hasFinancialReportData() {
      return this.financialReportInfoList.length > 0
    },

    // 判断是否有任何业务数据
    hasAnyData() {
      return this.hasLandTransferData ||
             this.hasAgriculturalSubsidyData ||
             this.hasContractData ||
             this.hasWarehouseData ||
             this.hasEntrustedData ||
             this.hasRealEstateData ||
             this.hasMarriageStatusData ||
             this.hasSocialSecurityData ||
             this.hasMedicalInsuranceData ||
             this.hasFinancialReportData
    },

    // 获取第一个可用的tab
    firstAvailableTab() {
      const tabs = [
        { name: 'landTransferData', condition: this.hasLandTransferData },
        { name: 'agriculturalSubsidyData', condition: this.hasAgriculturalSubsidyData },
        { name: 'contractData', condition: this.hasContractData },
        { name: 'warehouseData', condition: this.hasWarehouseData },
        { name: 'entrustedData', condition: this.hasEntrustedData },
        { name: 'realEstateData', condition: this.hasRealEstateData },
        { name: 'marriageStatus', condition: this.hasMarriageStatusData },
        { name: 'socialSecurity', condition: this.hasSocialSecurityData },
        { name: 'medicalInsurance', condition: this.hasMedicalInsuranceData },
        { name: 'financialReport', condition: this.hasFinancialReportData }
      ]

      const firstTab = tabs.find(tab => tab.condition)
      return firstTab ? firstTab.name : 'landTransferData' // 如果都没有，默认显示土地转移数据
    }
  },
  watch: {
    firstAvailableTab: {
      handler(newVal) {
        this.activeTab = newVal
      },
      immediate: true    //相当于初始化一次  后续持续监听 省去mounted中调用init方法
    }
  },
  methods: {
    handleTabClick(tab) {
      this.activeTab = tab.name
    }
  }
}
</script>

<style lang="less" scoped>
// 变量定义
@primary-color: #2563eb;
@primary-blue: #1677ff;
@text-primary: #1f2937;
@white: #ffffff;
@border-radius: 6px;

.business-card {
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
}

.business-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

// 暂无数据提示样式
.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  text-align: center;
  
  .no-data-icon {
    margin-bottom: 16px;
    
    i {
      font-size: 48px;
      color: #d1d5db;
    }
  }
  
  .no-data-text {
    font-size: 16px;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 8px;
  }
  
  .no-data-desc {
    font-size: 14px;
    color: #9ca3af;
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .business-card {
    padding: 16px;
  }
}

@media (max-width: 1024px) {
  .business-card {
    padding: 16px;
  }

  .business-title {
    font-size: 16px;
    margin-bottom: 16px;
  }
}

@media (max-width: 768px) {
  .business-card {
    padding: 12px;
  }

  .business-title {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .no-data-container {
    padding: 40px 16px;
    
    .no-data-icon i {
      font-size: 36px;
    }
    
    .no-data-text {
      font-size: 14px;
    }
    
    .no-data-desc {
      font-size: 12px;
    }
  }
}
</style>
